// @ts-ignore
import Vue from 'vue'
// @ts-ignore
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
// @ts-ignore
import { required, email, confirmed, regex } from 'vee-validate/dist/rules'
// @ts-ignore
import { Context } from '@nuxt/types/app'

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

export default ({ app }: Context) => {
  extend('required', {
    ...required,
    message: app.i18n.t('validation.rules.required') as string
  })

  extend('fullName', {
    validate: (value: string) => {
      const regex = /^[A-ZА-ЯЁ][a-zа-яё'-]{1,49} [A-ZА-ЯЁ][a-zа-яё'-]{1,49}$/

      return regex.test(value)
    },
    message: app.i18n.t('validation.rules.fullName') as string,
  })

  extend('email', {
    ...email,
    message: app.i18n.t('validation.rules.email') as string
  })

  extend('confirmed', {
    ...confirmed
  })

  extend('regex', {
    ...regex
  })

  extend('false', () => {
    return false
  })
}
